export class Coordinates {
  constructor(public rowNumber: number, public colNumber: number) {}
}
